import React from "react";
import { FaArrowRight } from "react-icons/fa";
import styles from "./About.module.css";

const About = () => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className="container">
        <div className="heading">
          <h2>About Me</h2>
          <span>My Introduction</span>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div
              className=" d-flex align-items-center h-100 w-100"
              data-aos="fade-right"
            >
              <img
                src="https://cdn.computercareers.org/wp-content/uploads/web-development.jpg"
                className="img-fluid rounded"
                alt=""
                style={{ width: "450px" }}
              />
            </div>
          </div>
          <div className="col-md-8">
            <div
              className="aboutText mt-5 mt-md-0 text-center"
              data-aos="fade-bottom"
            >
              <p>
                Hi, I’m Md Sahbir Hossain, a passionate and dedicated Full Stack
                Developer with expertise in the MERN stack (MongoDB, Express.js,
                React, Node.js). I specialize in building dynamic, scalable web
                applications and have a keen interest in creating seamless user
                experiences through clean, efficient code.
              </p>
              <p className="pt-2">
                With a strong foundation in both front-end and back-end
                development, I thrive in developing full-fledged applications
                using Next.js, Express.js, and React. My experience also spans
                database management with MongoDB, API integration, and ensuring
                responsive, mobile-friendly interfaces using Tailwind CSS and
                Bootstrap.
              </p>{" "}
              <p className="pt-2">
                When I’m not coding, I’m constantly learning and growing in the
                fields of Machine Learning and Natural Language Processing
                (NLP). My goal is to leverage technology to simplify processes
                and bring innovative solutions to the table.
              </p>
              <div className="row pt-4">
                <div className="col">
                  <h1 className="fw-bold">03+</h1>
                  <p>years</p>
                  <span>Experience</span>
                </div>
                <div className="col">
                  <h1 className="fw-bold">20+</h1>
                  <p>Completed</p>
                  <span>Projects</span>
                </div>
                <div className="col">
                  <h1 className="fw-bold">02+</h1>
                  <p>Companies</p>
                  <span>Worked</span>
                </div>
              </div>
              {/* <div className="pt-4">
                <a href="/Resume.pdf" download="/Resume.pdf">
                  <button className="mainBtn">
                    Resume <FaArrowRight />
                  </button>
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
